/**
 * ServiceTypeMarker — shared 14px non-circular type-marker badge.
 *
 * KAN-233 round 4: renders one lucide-react icon (white) on a colored
 * `rounded-sm` square (14px, `w-3.5 h-3.5`) — replaces the earlier
 * Cyrillic-letter badge. Used by BOTH the compact tree node dot
 * (`TreeNode.tsx`) and the `ServiceTypeLegend` swatch so the two stay
 * visually in sync (same shape, color and icon per `calculation_method`).
 */
import { METHOD_COLORS, METHOD_ICONS, METHOD_LABELS } from '@/utils/serviceFormula';

export function ServiceTypeMarker({ method, testId }: { method: string; testId: string }): JSX.Element {
  const Icon = METHOD_ICONS[method];
  return (
    <span
      data-testid={testId}
      title={METHOD_LABELS[method] || method}
      className={`inline-flex items-center justify-center w-3.5 h-3.5 rounded-sm flex-shrink-0 ${
        METHOD_COLORS[method] || 'bg-gray-400'
      }`}>
      {Icon && <Icon className="w-2.5 h-2.5 text-white" />}
    </span>
  );
}
